/**
 * Provider composition (CONTRACTS.md §2):
 * ToastProvider → AuthProvider → SyncProvider → PwaUpdatePrompt → children.
 * SyncProvider and PwaUpdatePrompt land from parallel workstreams; this file
 * codes against their contract exactly.
 */
import type { ReactNode } from 'react'
import { ToastProvider } from '@/components/ui'
import { AuthProvider } from '@/features/auth'
import { SyncProvider } from '@/services/sync'
import { PwaUpdatePrompt } from '@/pwa'

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <AuthProvider>
        <SyncProvider>
          <PwaUpdatePrompt />
          {children}
        </SyncProvider>
      </AuthProvider>
    </ToastProvider>
  )
}
